import {Action, handleActions} from "redux-actions";
import {none, option} from "ts-option";
import {SMS_FETCHED} from "../../action/sms/actionType";
import {SmsState} from "./SmsState";

/**
 * Initial state for text messages.
 */
const initState: SmsState = {
	textMessages: none,
};

const reducer = handleActions({
	[SMS_FETCHED]: (state: SmsState, action: Action<any>): SmsState => {
		return {...state, textMessages: option(action.payload.textMessages)}
	}
}, initState);

export default reducer;